import React from 'react';
import { Box, Text, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../constants';

import EventsList from '../components/BusinessEventsList';
import SupportButton from '../components/SupportButton';

const BusinessHomePage: React.FC = () => {
  const navigate = useNavigate();

  const getCurrentDate = () => {
    const date = new Date();
    return date.toLocaleDateString('en-US', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const handleShowInfluencers = (eventId: string, eventName: string) => {
    navigate(ROUTES.BUSINESS_INFLUENCERS, { state: { eventId, eventName } });
  };

  const handleProfileClick = () => {
    navigate(ROUTES.BUSINESS_PROFILE);
  };

  return (
    <Box className="base-container-long" 
      data-scroll-container="true"
      >

      {/* Navigation Bar */}
      <Box className='navigation-bar' justifyContent="space-between" paddingRight="24px">
        <Text className="title-text" >
          Home
        </Text>
        <SupportButton
          borderColor="#C6D959"
          hoverBorderColor="#C6D959"
          hoverBackgroundColor="rgba(198, 217, 89, 0.1)"
          backgroundColor="rgba(28, 28, 30, 0.8)"
        />
      </Box>

      {/* Date Display */}
      <Box
        position="absolute"
        top="104px"
        left="24px"
        zIndex={2}
      >
        <Text className="subtitle-text" >
          {getCurrentDate()}
        </Text>
      </Box>

      {/* Divider */}
      <Box className="navigation-bar-divider" />

      {/* Events List */}
      <EventsList 
        onShowInfluencers={handleShowInfluencers}
      />

      {/* Bottom Navigation Buttons */}
      <Box className="bottom-navigation-bar-box" >
        {/* Home Button */}
        <Button
          className="bottom-navigation-bar-button"
          onClick={() => navigate(ROUTES.BUSINESS_HOME)}
        >
          <svg width="18" height="20" viewBox="0 0 18 20" fill="none">
            <path
              d="M9 0L0 7V20H7V12H11V20H18V7L9 0Z"
              fill="#C6D959"
              stroke="none"
              strokeWidth="1.5"
            />
          </svg>
        </Button>

        {/* Add Button (instead of Favorites) */}
        <Button
          className="bottom-navigation-bar-button"
          onClick={() => {
            // Navigate to create event page
            navigate(ROUTES.BUSINESS_EVENT_CREATION);
          }}
        >          
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 5V19M5 12H19"
              stroke="#90909A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>

        {/* Profile Button */}
        <Button
          className="bottom-navigation-bar-button"
          onClick={handleProfileClick}
        >
          <svg width="16" height="18" viewBox="0 0 16 18" fill="none">
            <path
              d="M8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0ZM8 10C5.33 10 0 11.34 0 14V16C0 17.1 0.9 18 2 18H14C15.1 18 16 17.1 16 16V14C16 11.34 10.67 10 8 10Z"
              fill="none"
              stroke="#90909A"
              strokeWidth="1.5"
            />
          </svg>
        </Button>
      </Box>
    </Box>
  );
};

export default BusinessHomePage;
